import React, { useEffect, useState, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSectionNew';
import TableSection from 'components/sales/tableSection/tableSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import siteLog from '.';
import './sitelog.css';

const SiteLog = ({
  match,
  getSiteLog,
  siteLog
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const Headers = ['Site No','Created By', 'Site Action', 'Remark', 'Hold Reason', 'Created At'];
  const [isLoading, setIsLoading] = useState(false);
  

  useEffect(() => {
    if (getSiteLog !== null && match.params.id)
      (async () => {
        setIsLoading(true);
        await getSiteLog(match.params.id);
        setIsLoading(false);
      })();
  }, [getSiteLog, match.params.id]);

 

  return (
    <Layout
      title={'Back to Site Listing'}
      isGoback
      // linkFlag={true}
      linkUrl={
        `${baseUrl}/site-listing`
      }
      isLoading={isLoading}
    >
      <div>
        <FormSection title={'Site Log'}>
          <div className="details-listing">
            {console.log(siteLog)}
            { siteLog && 
            // <table className="panel-table">
            //     <thead>
            //       <th>S No</th>
            //       <th>Site No</th>
            //       <th>Created By</th>
            //       <th>Site Action</th>
            //       <th>Remark</th>
            //       <th>Created At</th>
            //     </thead>
            //     <tbody>
            //       {siteLog && siteLog.map((val)=>
            //       <>
            //         <td></td>
            //         <td></td>
            //         <td></td>
            //         <td></td>
            //         <td></td>
            //         <td></td>
            //       </>
            //       )}
                 
            //     </tbody>
            // </table>
            <TableSection
              data={siteLog}
              headers={Headers}
            ></TableSection> 
            }
          </div>
        </FormSection>

        
      </div>
      
    </Layout>
  );
};

export default SiteLog;
